export default __webpack_public_path__ + "static/media/Logo_EN_black.3971ad8b.png";